export default __webpack_public_path__ + "static/media/apple.6d3ef21f.png";